<div [formGroup]="parentForm()" [class.ms-xlarge-b]="displayMargin()">
  <div class="relative ps-xxsmall-b">
    @if (!disableLabel()) {
      <label
        class="font-body-1 regular-type flex ps-xxsmall-b font-body-medium text-icon-secondary"
        [for]="idOrControlName()"
        [ngClass]="{
          'nordic-blue-400-text': !control().invalid || !control().touched,
          'error-900-text': control().invalid && control().touched,
        }"
      >
        <div class="flex-1">
          {{ label() || (translationPrefix() + '.label' | finLocalization) }}
          @if (showAsterisk) {
            <span class="flex-1 flex--nogrow" data-testid="asterisk"> *</span>
          }
        </div>
        <ng-template #contentTooltip>
          <h2 class="font-body-1 bold-type nordic-blue-900-text text-icon-primary font-body-medium-bold">
            {{ tooltipHeading() }}
          </h2>
          <p class="pr-xxsmall-t nordic-blue-400-text text-icon-secondary">{{ tooltipContent() }}</p>
        </ng-template>
        @if (tooltipContent()) {
          <button
            type="button"
            fcomPopover
            [options]="tooltipOptions()"
            [content]="contentTooltip"
            [ariaCloseText]="'actions.close' | finLocalization"
            [attr.aria-label]="'actions.info' | finLocalization"
            class="icon nordic-blue-900-text text-icon-primary ms-small-r flex-1 flex--nogrow align-right"
            [class.error-900-text]="control().invalid && control().touched"
            [class.signal-error-notification-border-icon-text]="control().invalid && control().touched"
          >
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.HELP_BLOCK" />
          </button>
        }
      </label>
    }
    @if (ctrlField()) {
      <div class="relative">
        <select
          class="has-initial-value font-body-1 medium-type ps-small rounded-large fill font-label-medium"
          [ngClass]="{
            'grey-600-text text-icon-disabled-text': !control().value,
          }"
          [class.border]="themeService.siteTheme() === FinnairTheme.LEGACY"
          [class.border-formfields]="themeService.siteTheme() !== FinnairTheme.LEGACY"
          data-testid="select-from-list"
          [formControlName]="controlName()"
          [id]="idOrControlName()"
          [name]="controlName()"
          [attr.aria-required]="fieldRequired"
          #selectElement
        >
          @if (!disableSelectOption()) {
            <option value [selected]="!ctrlField().value">
              {{ selectLabelTranslationKey() | finLocalization }}
            </option>
          }
          @for (option of options() ?? []; track option.trackByVal ?? option.value) {
            <option
              [value]="option.value"
              [disabled]="option.disabled"
              [selected]="option.value === ctrlField().value"
              class="font-body-1 font-body-medium"
            >
              {{ option.name ? option.name : (translationPrefix() + '.' + option.value | finLocalization) }}
            </option>
          }
        </select>
        <fcom-icon
          class="chevron-icon absolute ms-small-t icon-medium ms-small-r nordic-blue-900-text text-icon-primary"
          [ngClass]="{ 'grey-600-text text-icon-disabled-text': control().disabled }"
          [name]="SvgLibraryIcon.CHEVRON_DOWN"
          dataTestId="select-from-list-chevron"
        />
      </div>
    }
    <span class="divider"></span>
  </div>
  @if (ctrlField().invalid && ctrlField().touched) {
    <div class="error-label font-body-2 font-body-small" aria-live="polite" role="alert">
      @if (ctrlField().errors?.required) {
        <span class="error-900-text signal-error-notification-border-icon-text">
          {{ translationPrefix() + '.required' | finLocalization }}
        </span>
      }
    </div>
  }
</div>
